__turbopack_context__.v({
  "search": "articles-search-module-scss-module__yxmTGa__search",
});
